export default __webpack_public_path__ + "static/media/manda.14925853.svg";